import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { Button, Link } from 'base-ui'

import { StaticImage } from '../../../image'
import { urlResolverGoToNfcAtShopApothekeApp } from '../../../url-handling'

import appQRCode from './app-qr-code.png'
import phone from './phone.png'

export const NfcLandingPageHowItWorksSectionAppBannerMobile: FC = () => {
  const intl = useIntl()

  return (
    <Link
      className="flex gap-3 rounded-2xl bg-light-secondary-medium text-inherit no-underline hover:text-inherit tablet:gap-6 tablet:px-6"
      href={urlResolverGoToNfcAtShopApothekeApp()}
      /*
       * `id` added to build a bridge between web and app, allowing to change this element dynamically
       * ref: https://jira.shop-apotheke.com/browse/WSERX-575
       */
      id="app_deeplink"
    >
      <div className="relative -ml-3 flex-[2]">
        <StaticImage
          alt={intl.formatMessage({
            id: 'nfc.howItWorks.images.phoneWithApp',
          })}
          className="object-contain object-bottom tablet:object-right-bottom"
          fill
          src={phone}
        />
        <div className="absolute bottom-16 right-28 hidden size-[103px] items-center justify-center rounded-full bg-light-tertiary text-center font-mono text-s font-medium uppercase tablet:flex">
          <FormattedMessage id="nfc.howItWorks.banner.badge" />
        </div>
      </div>

      <div className="flex flex-[2] flex-col gap-4 p-6 pl-0 tablet:flex-[3]">
        <div className="flex flex-col items-start">
          <span className="text-m font-medium tablet:text-2xl">
            <FormattedMessage id="nfc.howItWorks.banner.title.new" />
            <span className="hidden whitespace-nowrap italic text-dark-accent tablet:block">
              <FormattedMessage id="nfc.howItWorks.banner.highlightedText.new" />
            </span>
          </span>

          <span className="mt-3 text-s tablet:hidden">
            <FormattedMessage id="nfc.howItWorks.banner.description" />
          </span>

          <Button className="mt-3 tablet:hidden" size="small">
            <FormattedMessage id="nfc.howItWorks.banner.appBtn" />
          </Button>
        </div>

        <div className="hidden items-center gap-4 rounded-2xl bg-light-primary-low p-4 tablet:flex">
          <StaticImage
            alt={intl.formatMessage({
              id: 'nfc.howItWorks.images.appQR',
            })}
            height={80}
            src={appQRCode}
            width={80}
          />
          <span className="text-m font-medium">
            <FormattedMessage id="nfc.howItWorks.banner.appText" />
          </span>
        </div>
      </div>
    </Link>
  )
}
